"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinPostingRuleSchema = exports.createFinPostingRuleSchema = exports.finPostingRuleShape = exports.finFinancialEventTypeEnum = void 0;
const zod_1 = require("zod");
/**
 * Enterprise Architecture Handbook v1.0 (OP Billing Administration,
 * Module 3 — Auto Posting Rules). Mirrors the real `FinFinancialEventType`
 * Prisma enum verbatim (`prisma/schema.prisma`) — every event type the
 * Auto-Posting Engine can match a rule against, not the 8-value subset
 * `recordPostingEventRequestSchema` uses for its one runtime endpoint.
 */
exports.finFinancialEventTypeEnum = zod_1.z.enum([
    'CHARGE_POSTED',
    'PAYMENT_RECEIVED',
    'ADVANCE_RECEIVED',
    'DEPOSIT_RECEIVED',
    'DISCOUNT_APPLIED',
    'REFUND_PROCESSED',
    'ADJUSTMENT_POSTED',
    'PACKAGE_SOLD',
    'CHARGE_INVOICED',
    'CHARGE_INVOICED_INSURANCE',
    'WRITE_OFF_POSTED',
    'WRITE_OFF_POSTED_INSURANCE',
    'CREDIT_NOTE_ISSUED',
    'CREDIT_NOTE_ISSUED_INSURANCE',
    'DEBIT_NOTE_ISSUED',
    'DEBIT_NOTE_ISSUED_INSURANCE',
    'VENDOR_INVOICE_POSTED',
    'VENDOR_PAYMENT_MADE',
    'VENDOR_ADVANCE_PAID',
    'VENDOR_ADVANCE_APPLIED',
    'VENDOR_CREDIT_NOTE_ISSUED',
    'VENDOR_DEBIT_NOTE_ISSUED',
    'VENDOR_INVOICE_WRITE_OFF_POSTED',
    'BANK_DEPOSIT',
    'BANK_WITHDRAWAL',
    'BANK_TRANSFER',
    'CASH_TRANSFER',
    'CHEQUE_RECEIVED',
    'CHEQUE_ISSUED',
    'CHEQUE_CLEARED_RECEIVED',
    'CHEQUE_CLEARED_ISSUED',
    'CASH_SESSION_SHORTAGE_POSTED',
    'CASH_SESSION_OVERAGE_POSTED',
    'PHARMACY_RETAIL_SALE_POSTED',
    'PHARMACY_CREDIT_SALE_POSTED',
    'INVENTORY_WRITE_OFF_POSTED',
]);
exports.finPostingRuleShape = {
    eventType: exports.finFinancialEventTypeEnum,
    journalTemplateId: zod_1.z.string().uuid(),
    costCenterId: zod_1.z.string().uuid().optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
};
exports.createFinPostingRuleSchema = zod_1.z.object(exports.finPostingRuleShape);
exports.updateFinPostingRuleSchema = zod_1.z.object(exports.finPostingRuleShape).partial();
//# sourceMappingURL=fin-posting-rule.schema.js.map